// extracted by mini-css-extract-plugin
export default {"mealTable":"bNRXWglpM6w217ESIm11"};